export default {"src":"/_next/static/media/closeEye.c99d961b.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};